import { Lit3formBlock, html, unsafeHTML } from '@Root/lib/lit-3form-block';
import { styles } from './css';
import {
  analyticsCtaDataObject,
  analyticsLabelFromString,
  handleAdobeNavEvent,
} from '../../../helpers/adobe-analytics';

export class Bobby extends Lit3formBlock {
  static get characterName() {
    return 'bobby';
  }

  static get characterStyles() {
    return [...styles];
  }

  render() {
    return html`
      <div class="block-wrapper">
        <div class="block-grid bobby-layout">
          ${!!this.headerText
            ? html`
                <h2 class="block-title">${unsafeHTML(this.headerText)}</h2>
              `
            : html``}
          ${!!this.descriptionRaw
            ? html`
                <p class="block-description">
                  ${unsafeHTML(this.withLineBreaks(this.descriptionRaw))}
                </p>
              `
            : html``}
          ${this.ctaHTML}
          ${this.imagesArr.length
            ? html`
                <div class="images">
                  ${this.imagesArr.map(i => this.imageHTML(i[1]))}
                </div>
              `
            : html``}
          ${this.horizontalRule}
        </div>
      </div>
    `;
  }

  imageHTML(image) {
    const ctaInfo = JSON.stringify({
      url: image.url || '',
      text: image.text || '',
    });
    const hasCta = !!image.text && !!image.url;

    return html`
      <div class="image-container">
        ${image.url
          ? html`
              <a
                class="image-link"
                href="${image.url}"
                @click="${event => this.handleImageClick(image, event)}"
              >
                <img
                  class="image"
                  src=${this.imagebossUrl(image.src, null, '395')}
                />
              </a>
            `
          : html`
              <img
                class="image"
                src=${this.imagebossUrl(image.src, null, '395')}
              />
            `}
        ${hasCta
          ? html`
              <cta-text
                class="image-cta"
                cta-data=${ctaInfo}
                .ctaAnalyticsData=${analyticsCtaDataObject(
                  { ...image, destinationUrl: image.url },
                  this.headerText
                )}
              ></cta-text>
            `
          : html``}
      </div>
    `;
  }

  handleImageClick(image, event) {
    handleAdobeNavEvent({
      navString: `NAV|${analyticsLabelFromString(
        this.headerText || 'Bobby'
      )}|${analyticsLabelFromString(image.text || image.url)}`,
      destinationUrl: image.url,
      event,
    });
  }

  get descriptionRaw() {
    return this.content.description || '';
  }

  get ctaHTML() {
    const cta = this.content.call_to_action;
    if (!cta) return html``;

    const ctaType = cta.type === 'Primary button' ? 'primary' : 'download';
    const ctaInfo = JSON.stringify(cta);

    return html`
      <cta-button
        class="block-cta"
        cta-data=${ctaInfo}
        cta-type=${ctaType}
        .ctaAnalyticsData=${analyticsCtaDataObject(ctaInfo, this.headerText)}
      ></cta-button>
    `;
  }
}
Bobby.defineElement();
